import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgNfAngleRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 4 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.117.757A.48.48 0 01.116.13.368.368 0 01.633.086L.678.13l3.205 3.557a.481.481 0 01.039.578l-.039.05L.678 7.87a.37.37 0 01-.562-.001.483.483 0 01-.038-.577l.039-.05L3.039 4 .117.757z"
  })));
}

export { SvgNfAngleRightWhite as ReactComponent };
//# sourceMappingURL=nf_angleRightWhite.svg.js.map
